import { useWebsiteBanner } from '@shared/components/WebsiteBanner';
import { useTranslation, useHistory } from '@shared/core';

interface UseAccommodationsVisibilityBannerDisplayArgs
  extends Readonly<{
    eventHandle: string;
    isVisible: boolean;
    onClose?: () => void;
  }> {}

/**
 * Registers the accommodations visibility banner.
 * Shows when the 'Where to Stay' page is hidden from guests.
 */
export const useAccommodationsVisibilityBannerDisplay = (args: UseAccommodationsVisibilityBannerDisplayArgs) => {
  const { eventHandle, isVisible, onClose } = args;
  const { tq } = useTranslation('publishReminder');
  const history = useHistory();

  useWebsiteBanner({
    id: 'accommodations-visibility',
    isVisible,
    message: {
      default: tq`Your 'Where to Stay' page is hidden from guests. Enable it when you're ready to share.`,
      mobile: tq`Your 'Where to Stay' page is hidden from guests.`,
    },
    actionButton: {
      label: {
        default: tq`Update Visibility`,
        mobile: tq`Update`,
      },
      onClick: () => {
        const path = `/${eventHandle}/edit/accommodations?settings=true`;
        history.push(path);
      },
    },
    onClose,
  });
};
